<div class="min-h-[85vh] bg-gray-200 flex items-center justify-center px-4 py-10">

  <div class="max-w-6xl w-full grid grid-cols-1 lg:grid-cols-2 gap-8">

    <!-- ================= ACCOUNT INFO CARD ================= -->
    <div class="bg-white rounded-2xl shadow-xl p-8">

      <!-- Profile Section -->
      <div class="flex items-center gap-5 mb-6 border-b pb-6">

        <!-- Profile Image -->
        <img [src]="caData?.documents[0]?.doc_user_img" alt="Profile"
          class="w-20 h-20 rounded-full border-4 border-[#006269] shadow-md">

        <div>
          <h2 class="text-xl font-semibold text-gray-800">
            {{ caData?.name }} {{ caData?.user_last_name }}
          </h2>
          <!-- <p class="text-sm text-gray-500">Chartered Accountant</p> -->
        </div>

      </div>

      <!-- Info Grid -->
      <div class="grid grid-cols-1 sm:grid-cols-2 gap-6 text-sm">

        <div>
          <p class="text-gray-500">Email</p>
          <p class="font-medium text-gray-800">{{ caData?.email}}</p>
        </div>

        <div>
          <p class="text-gray-500">Phone</p>
          <p class="font-medium text-gray-800">{{ caData?.mobilenumber}}</p>
        </div>

        <div>
          <p class="text-gray-500">Gender</p>
          <p class="font-medium text-gray-800">{{ caData?.user_gender}}</p>
        </div>

        <div>
          <p class="text-gray-500">Account Status</p>
          <span class="inline-block px-3 py-1 text-xs font-medium bg-green-100 text-green-700 rounded-full">
            Active
          </span>
        </div>

      </div>

    </div>


    <!-- ================= RESET PASSWORD CARD ================= -->
    <div class="bg-white rounded-2xl shadow-xl p-8">

      <div class="mb-8">
        <h2 class="text-2xl font-semibold text-[#006269]">
          Reset Password
        </h2>
        <p class="text-gray-500 text-sm mt-1">
          Update the account password securely
        </p>
      </div>

      <form>

        <!-- Email -->
        <div class="mb-5">
          <label class="block text-sm font-medium text-gray-600 mb-2">
            Email
          </label>
          <input readonly type="email" name="email" [(ngModel)]="email"
            class="w-full border border-gray-300 rounded-lg px-4 py-2 bg-gray-100 outline-none" readonly />
        </div>

        <!-- New Password -->
        <div class="mb-5">
          <label class="block text-sm font-medium text-gray-600 mb-2">
            New Password
          </label>
          <input type="password" name="password" [(ngModel)]="password" placeholder="Enter new password"
            class="w-full border border-gray-300 rounded-lg px-4 py-2 focus:border-[#006269] focus:ring-1 focus:ring-[#006269] outline-none transition" />
        </div>

        <!-- Confirm Password -->
        <div class="mb-7">
          <label class="block text-sm font-medium text-gray-600 mb-2">
            Confirm Password
          </label>
          <input type="password" name="master_password" [(ngModel)]="master_password" placeholder="Confirm new password"
            class="w-full border border-gray-300 rounded-lg px-4 py-2 focus:border-[#006269] focus:ring-1 focus:ring-[#006269] outline-none transition" />
        </div>

        <!-- Button -->
        <button type="button" (click)="updatePassword()"
          class="w-full bg-[#006269] hover:bg-[#a67f1f] text-white font-semibold py-2.5 rounded-lg transition duration-200 shadow-md hover:shadow-lg">
          Update Password
        </button>

      </form>

    </div>

  </div>

</div>